<template>
  <BasicTemplate>
    <h3>
      <router-link to="/games">Games</router-link>
      /
      Game #{{ $route.params.id }}
    </h3>
    <GameForm :item="item" @save="save()" />
  </BasicTemplate>
</template>

<script>
import BasicTemplate from '../../templates/basic.vue';
import GameForm from './form.vue';

export default {
  name: 'GameEdit',
  components: {BasicTemplate, GameForm},
  data() {
    return {
      item: {
        subscriberOnlyGame: null,
        gamePrerollSettings: null,
        supportInfo: null
      }
    };
  },
  async created() {
    this.$watch(() => this.$route.params, () => this.load());
    await this.load();
  },
  methods: {
    async load() {
      const {id} = this.$route.params;
      this.item = await this.$gameApi.get(`/games/${id}`);
    },
    async save() {
      try {
        // Prepare data for saving
        const dataToSave = { ...this.item };
        
        // Normalize and decide whether to send null for gamePrerollSettings
        const wasNull = !!dataToSave.__prerollWasNull;
        if (dataToSave.gamePrerollSettings) {
          const s = dataToSave.gamePrerollSettings;
          if (s.freePeriod === '' || (typeof s.freePeriod === 'string' && s.freePeriod.trim() === '')) s.freePeriod = null;
          if (s.seconds === '' || (typeof s.seconds === 'string' && s.seconds.trim() === '')) s.seconds = null;
          if (s.firstStartRate === '' || (typeof s.firstStartRate === 'string' && s.firstStartRate.trim() === '')) s.firstStartRate = null;
          if (s.showRate === '' || (typeof s.showRate === 'string' && s.showRate.trim() === '')) s.showRate = null;
          // Clamp min values to 0 when numbers are provided
          if (typeof s.freePeriod === 'number' && s.freePeriod < 0) s.freePeriod = 0;
          if (typeof s.seconds === 'number' && s.seconds < 0) s.seconds = 0;
          if (typeof s.firstStartRate === 'number' && s.firstStartRate < 0) s.firstStartRate = 0;
          if (typeof s.showRate === 'number' && s.showRate < 0) s.showRate = 0;
          // Convert numeric fields to integers (except isEnabled)
          if (typeof s.freePeriod === 'number') s.freePeriod = Math.floor(s.freePeriod);
          if (typeof s.seconds === 'number') s.seconds = Math.floor(s.seconds);
          if (typeof s.firstStartRate === 'number') s.firstStartRate = Math.floor(s.firstStartRate);
          if (typeof s.showRate === 'number') s.showRate = Math.floor(s.showRate);
          // Always include numeric gameId when sending an object
          s.gameId = parseInt(this.$route.params.id, 10);
          // If it was null originally and user kept it as not set (no values and not enabled), send isEnabled: null
          const hasAnyValues = s.freePeriod !== null || s.seconds !== null || s.firstStartRate !== null || s.showRate !== null || s.isEnabled === true;
          if (wasNull && !hasAnyValues) {
            const gameIdNum = parseInt(this.$route.params.id, 10);
            dataToSave.gamePrerollSettings = {
              gameId: gameIdNum,
              isEnabled: null,
              freePeriod: null,
              seconds: null,
              firstStartRate: null,
              showRate: null
            };
          }
        } else if (wasNull) {
          // Explicitly send an object with isEnabled: null if nothing provided and was null
          const gameIdNum = parseInt(this.$route.params.id, 10);
          dataToSave.gamePrerollSettings = {
            gameId: gameIdNum,
            isEnabled: null,
            freePeriod: null,
            seconds: null,
            firstStartRate: null,
            showRate: null
          };
        }
        // Do not send helper flag to API
        delete dataToSave.__prerollWasNull;
        
        await this.$gameApi.patch(`/games/${this.$route.params.id}`, {
          ...dataToSave,
          subscriberOnlyGame: this.item.subscriberOnlyGame || null
        });
        this.$swal.fire({icon: 'success', title: 'Game saved.', timer: 1500, showConfirmButton: false});
        this.item = await this.$gameApi.get(`/games/${this.$route.params.id}`);
      } catch (e) {
        this.$swal.fire({icon: 'error', title: e.message, timer: 1500, showConfirmButton: false});
      }
    }
  }
};
</script>

